/**
 * ★ ALL-TIME VIEWS, READ IN ONE PLACE (the owner, 2026-10-05: "for the author it is one app, one
 * data - no separate 'earlier views'"). Views are named by TIME, never by where they happened:
 * "Views" is the chosen period's, as it always was, and "All-time views" is every view ever, from
 * the old MoonX apps and ours, in one number - the server's `allTimeViews` on `Dashboard` and on
 * each `ArticleStats` row. Shown, never paid: pay is the counted views, and nothing here moves it.
 * What design 14 drew beside the figures - "Your articles also have 1,234 earlier views", "1,234
 * earlier" under a row's views, "1,234 earlier views" on a card - is gone; those views are inside
 * the all-time figure now, so no screen says "earlier" about views any more.
 *
 * ★ A SERVER FROM BEFORE THAT CHANGE SENDS NO `allTimeViews` - the owner's live stack until it is
 * rebuilt - though the generated type says it always does. So the member is read as `unknown` and
 * trusted only when it is a number. When it is not, the deprecated `oldAppViews` stands in for it:
 * before launch nobody reads in the new apps, so the old apps' total IS the all-time total. When
 * neither is a number the answer is `undefined` and the screen leaves the figure out - it never
 * invents one, and it never adds the period's views to anything: a period's figure and an all-time
 * one summed would count the same view twice.
 *
 * Every screen that shows the figure reads it here: the Overview
 * (routes/dashboard/DashboardRoute.tsx), Statistics' Overview tab and its per-article table
 * (routes/articles/StatsOverview.tsx and ArticleStatsRoute.tsx), and the cards on My articles
 * (routes/articles/card-figures.tsx).
 */
import type { ArticleStats, Dashboard } from './api';

/** Every view ever, for the author or for one article - or `undefined` when the answer has none. */
export function allTimeViewsOf(answer: Dashboard | ArticleStats): number | undefined {
  const allTime: unknown = answer.allTimeViews;
  if (typeof allTime === 'number') {
    return allTime;
  }
  // The server from before the change (see the header): its old-app total is everything there was.
  const oldApps: unknown = answer.oldAppViews;
  return typeof oldApps === 'number' ? oldApps : undefined;
}
